<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="section-gap">
        <div class="block">
          <div class="ad-set-module-container">
            <p class="title">名称</p>
            <input class="block input width-3" v-model="initialData.name">
            <p class="title">生效时间</p>
            <div class="block">
              <el-date-picker
                      v-model="initialData.startTime"
                      type="datetime"
                      placeholder="放行开始时间"
                      align="right">
              </el-date-picker>
              <span class="r-top">~</span>
              <el-date-picker
                      v-model="initialData.endTime"
                      type="datetime"
                      placeholder="放行结束时间"
                      align="right">
              </el-date-picker>
            </div>
            <p class="title">上传图片</p>
            <div class="block">
              <span class="button is-primary" id="js_imageUploadBtn" style="line-height: 30px;">上传图片</span>
              <span class="upload-img-tips">只能上传 jpg/png 文件，图片尺寸小于1M</span>
            </div>
            <div class="block">
              <image-component :image="initialData.image" :width="300"></image-component>
              <p v-if="initialData.image.image" style="margin-top: 10px;">曝光权重<input class="block input width-2" v-model="initialData.weight"> <span @click="onRemove" style="margin-left: 20px; color: #f00;">删除</span></p>
            </div>
            <p class="title">跳转页面</p>
            <div class="block cyzs-w-400">
              <custom-link :link='initialData.link' @update:link="val => { initialData.link = val }"></custom-link>
            </div>

            <div class="block">
              <p class="title" style="margin-top: 30px;">用户分群</p>
              <div class="control">
                <div class="inline-block">
                      <span class="radio r-top">
                        <input type="checkbox" value="1" v-model="initialData.showUserStatus">未付费用户可见
                         <input type="checkbox" value="2" v-model="initialData.showUserStatus">其他用户可见
                      </span>
                </div>
              </div>
              <p class="title" style="margin-top: 30px;">应用页面</p>
              <div class="control">
                <div class="inline-block">
                    <span class="radio r-top">
                      <input type="checkbox" id="result" name="result" value="0" v-model="initialData.result" >
                      <label for="storage">搜索结果页</label>
                    </span>
                  <span class="radio r-top">
                      <input type="checkbox" id="cart" name="cart" value="1" v-model="initialData.cart" >
                      <label for="onSale">购物车页</label>
                    </span>
                  <span class="radio r-top">
                      <input type="checkbox" id="goodsDetail" name="goodsDetail" value="2" v-model="initialData.goodsDetail" >
                      <label for="onSale">商品详情页</label>
                    </span>
                </div>
              </div>
            </div>
            <button class="button is-primary" style="margin: 60px 0 40px 0;" @click="saveModuleClick">保存</button>
            <button class="button is-success" style="margin: 60px 0 40px 0;" @click="backClick">返回</button>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import CustomLink from 'COMMON/DefinedLink'

export default {
  components: { CustomLink },
  data () {
    return {
      // 模块设置
      initialData: {
        name: '',
        status: 1,
        startTime: '',
        endTime: '',
        link: '',
        weight: 1,
        image: {
          image: '',
          width: 0,
          height: 0
        },
        isNewUser: '',
        result: '',
        cart: '',
        goodsDetail: '',
        showUserStatus: [1, 2]
      },
      advId: ''
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.uploadMainBind()
    })
    this.advId = this.$route.query.advId
    if (this.advId) {
      this.getInit()
    }
  },
  methods: {
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: true
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.initialData.image.image = response.data.images.info.path
            this.initialData.image.width = response.data.images.info.width
            this.initialData.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },

    // 保存模块设置
    saveModuleClick () {
      if (!this.initialData.name) {
        this.$message('请填写广告名称！')
        return
      }
      let params = Object.assign({}, this.initialData)
      if (params.isNewUser) {
        params.isNewUser = 1
      } else {
        params.isNewUser = 0
      }
      let format = []
      if (this.initialData.result === true) {
        format.push(1)
      }
      if (this.initialData.cart === true) {
        format.push(2)
      }
      if (this.initialData.goodsDetail === true) {
        format.push(3)
      }
      if (!this.initialData.result && !this.initialData.cart && !this.initialData.goodsDetail) {
        format.push(0)
      }
      params.pages = format
      HttpRequest.post('/admin.php?method=activity11.doSaveSpecialAdv', params, true).then((response) => {
        if (response.data.success == 1) {
          this.$message('保存成功')
          setTimeout(() => {
            this.$router.push({
              name: 'specialAdvertisement'
            })
          }, 1000)
        } else {
          this.$message('接口错误,请联系管理员')
        }
      }, (response) => {

      })
    },
    backClick () {
      this.$router.push({
        name: 'specialAdvertisement'
      })
    },
    onRemove () {
      this.initialData.image = {
        image: '',
        width: 0,
        height: 0
      }
    },
    getInit () {
      HttpRequest.get('/admin.php?method=activity11.getSpecialAdv', {advId: this.advId}, true).then((response) => {
        this.initialData = Object.assign(this.initialData, response.data)
        if (!response.data.showUserStatus || response.data.showUserStatus.length == 0) {
          this.initialData.showUserStatus = [1, 2]
        } else {
          this.initialData.showUserStatus = response.data.showUserStatus
        }
        _.each(response.data.pages, (item, index) => {
          if (parseInt(item) === 1) {
            this.initialData.result = true
          } else if (parseInt(item) === 2) {
            this.initialData.cart = true
          } else if (parseInt(item) === 3) {
            this.initialData.goodsDetail = true
          }
        })
      }, (response) => {

      })
    }
  }
}
</script>
<style lang="less" scoped>
  .ad-list-container{
    margin: 30px 0;
    .list-cell{
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
  .ad-set-module-container{
    margin: 30px 0 0 4px;
    .slider-wrap{
      width: 300px;
      margin-top: 40px;
      .tooltip-value{
        margin-left: 20px;
      }
      .input-slider{
        margin-top: 30px;
      }
    }
  }
  .white-space {
    white-space: normal;
  }
  .custom-link-wrap{
    border-radius: 6px;
    border: 1px solid #00d1b2;
    width: 300px;
    padding: 20px;
  }
</style>
